import cn from 'classnames';

import type { Config, Id } from '../config';
import css from './contributors.module.scss';

interface Props {
    sections: Config;
    selected: Id;
    onSelect(id: Id): void;
}
export function Contributors({ sections, selected, onSelect }: Props) {
    return (
        <aside className={css.wrapper}>
            <p className={css.heading}>Key contributors</p>
            <ul className={css.list}>
                {Object.entries(sections).map(([_, { id, title, status, icon, count, subtitle }]) => (
                    <li key={id}>
                        <button
                            onClick={() => onSelect(id)}
                            className={cn(css.item, { [css.active]: selected === id })}
                        >
                            <span className={css.icon}>{icon}</span>
                            <span className={css.text}>
                                <span className={css.title}>{title}</span>
                                <span className={css.subtitle}>{subtitle}</span>
                            </span>
                            {id === 'raw' ? (
                                <span className={css.link}>View raw key ›</span>
                            ) : (
                                <span
                                    className={cn(css.meta, {
                                        [css.error]: status === 'error',
                                        [css.warning]: status === 'warning',
                                    })}
                                >
                                    <span
                                        className={cn(css.badge, {
                                            [css.error]: status === 'error',
                                            [css.warning]: status === 'warning',
                                        })}
                                    >
                                        {status === 'success' ? '✓' : status === 'warning' ? '!' : '✕'}
                                    </span>
                                    <span className={css.count}>{count}</span>
                                </span>
                            )}
                        </button>
                    </li>
                ))}
            </ul>
        </aside>
    );
}
